import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import { RendererPageCoverPicturePlaceholder } from '../src/RendererCoverPicture/RendererPageCoverPicturePlaceholder.tsx';
import type { RendererPageCoverPictureComponentProps } from '../src/pageCoverPictureTypes.ts';

export const RendererPageCoverPicture: LoadableType<RendererPageCoverPictureComponentProps> =
	LoadableAfterPaint({
		loader: async () => {
			return (
				await import(
					/* webpackChunkName: "loadable-RendererCoverPictureRendererPageCoverPicture" */ '../src/RendererCoverPicture/RendererPageCoverPicture.tsx'
				)
			).RendererPageCoverPicture;
		},
		loading: RendererPageCoverPicturePlaceholder,
	});
